export default __webpack_public_path__ + "static/media/icon-drop.9c04f6de.svg";